import { Box, Text } from '@chakra-ui/react'
import { PracticeVisit, VISITS, WithId } from '@hb/shared'
import { useDocument } from '../../../backend/db/hooks/useDocument'
import { Loading } from '../../../components/Loading'
import { DefaultModal } from '../../../components/Modals/DefaultModal'
import { VisitView } from './VisitView'

export const VisitViewModal = ({
  visit,
  onClose,
}: {
  visit: WithId<PracticeVisit>
  onClose: () => void
}) => (
  <DefaultModal
    isOpen
    size="2xl"
    overlayHeader
    onClose={onClose}
    contentProps={{ p: 0, bg: 'gray.50' }}
    render={() => <VisitView onClose={onClose} visit={visit} />}
  />
)

export const VisitIdViewModal = ({
  visitId,
  onClose,
}: {
  visitId: string
  onClose: () => void
}) => {
  const { data: visit, loading } = useDocument<PracticeVisit>(VISITS, visitId)
  let body = <></>
  if (visit) {
    body = (
      <Box w="100%">
        <VisitView onClose={onClose} visit={visit} />
      </Box>
    )
  } else if (loading) {
    body = <Loading text="Loading visit..." />
  } else {
    body = (
      <Text color="red.600" p={3}>
        Could not load visit
      </Text>
    )
  }
  return (
    <DefaultModal
      isOpen
      size="2xl"
      overlayHeader
      onClose={onClose}
      closeDisabled={!!visit}
      contentProps={{ p: 0, bg: 'gray.50' }}
      render={() => body}
    />
  )
}
